export default __webpack_public_path__ + "static/media/folder-tab-icon.458f2fa9.svg";